import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1fce7c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打卡名单", -1))
const _hoisted_2 = { class: "list_scroll" }
const _hoisted_3 = { class: "list_form" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "liveList" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "liveSet_head" }, "打卡时间"),
  /*#__PURE__*/_createElementVNode("p", { class: "liveSet_head" }, "观众昵称")
], -1))
const _hoisted_5 = { class: "liveSet_tab" }
const _hoisted_6 = { style: {"color":"#505d6f"} }
const _hoisted_7 = { class: "span_name" }
const _hoisted_8 = { class: "primary_pagination" }

import { getCurrentInstance, reactive, ref } from 'vue';
import { message, Pagination, Collapse, Empty, notification } from 'ant-design-vue';
// import { DownOutlined } from '@ant-design/icons-vue';
import http from '@/api';
import { useRoute } from 'vue-router';
import { punchEmpty } from '@/assets';
import CLoading from '@/components/CLoading.vue';
import { getToken } from '@/plugins/cookie';
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList'
import { useDebounce } from '@/hooks/useDebounce'; //防抖


interface DataItem {
  id: number;
  sing_at: string;
  sing_name?: any;
}
//   分页

export default /*#__PURE__*/_defineComponent({
  __name: 'PunchList',
  emits: ['createStatus'],
  setup(__props, { emit }) {

const aEmpty = Empty;
const aPagination = Pagination;
const aCollapse = Collapse;
const aCollapsePanel = Collapse.Panel;

const showLoading = ref<boolean>(false);
const route = useRoute();

const goBack = () => {
  emit('createStatus', true);
};
const mediaRef = ref();

const Postes = ref<DataItem[]>([]);
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 10, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
const showSize = () => {
  // console.log('ssss');
};
// 获取直播间打卡记录
const singName = ref('');
const singInInList = () => {
  let inList = {
    studio_id: route.params.studioId,
    page: pageConfigure.current,
    page_num: pageConfigure.pageSize,
  };
  showLoading.value = true;
  http.liveExpress
    .getSingInInList({ params: inList })
    .then((res) => {
      showLoading.value = false;
      pageConfigure.current = res.data.data.current_page;
      pageConfigure.totalSize = res.data.data.total > 0 ? res.data.data.total : 10;
      Postes.value = [...res.data.data.data];
      let arr = JSON.parse(JSON.stringify(Postes.value));
      arr.forEach((item: any) => {
        singName.value = item.sing_name;
      });
    })
    .catch((res) => {
      showLoading.value = false;
      message.destroy();
      message.error(res.data.error);
    });
};
singInInList();

const { proxy }: any = getCurrentInstance();
const corn = ref(1)
const messageTip = ref()
const exportOut = useDebounce((type: number) => {
  // window.location.href  = `${proxy.$exportUrl}?token=${getToken()}&studio_id=${route.params.studioId}&type=${type}&is_cron_download=${corn.value}`;
  // onExport(url);
  const data = {
        studio_id: route.params.studioId,
        type: type,
        is_cron_download: corn.value,
      };
      https.excel_regional_distribution({params:data})
        .then((res: any) => {
            messageTip.value = res.data.message
          openNotificationWithIcon('success')
        })
        .catch((res: any) => {
          messageTip.value = res.data.error
          openNotificationWithIcon('error')
        });

});
const openNotificationWithIcon = (type: string) => {
      notification[type]({
        message: messageTip.value,
       duration: 5,
      });
    };

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mediaRef",
    ref: mediaRef
  }, [
    _createElementVNode("div", { class: "list_nav" }, [
      _hoisted_1,
      _createElementVNode("div", {
        class: "nav_return",
        onClick: goBack
      }, "返回 >>")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(aCollapse), { expandIconPosition: "right" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Postes.value, (item, index) => {
                return (_openBlock(), _createBlock(_unref(aCollapsePanel), {
                  key: index,
                  "show-arrow": item.sing_name.length > 1,
                  disabled: item.sing_name.length === 1
                }, {
                  header: _withCtx(() => [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.sing_at), 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.sing_name[0]), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sing_name, (i, j) => {
                      return _withDirectives((_openBlock(), _createElementBlock("p", {
                        class: "p_right",
                        key: j
                      }, _toDisplayString(i), 1)), [
                        [_vShow, j > 0]
                      ])
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["show-arrow", "disabled"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createVNode(_unref(aPagination), {
            "show-quick-jumper": "",
            "show-size-changer": "",
            total: pageConfigure.totalSize,
            current: pageConfigure.current,
            "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((pageConfigure.current) = $event)),
            "page-size": pageConfigure.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageConfigure.pageSize) = $event)),
            pageSizeOptions: pageConfigure.options,
            onShowSizeChange: showSize,
            onChange: showSize
          }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]), [
            [_vShow, Postes.value.length < 0]
          ])
        ])
      ]),
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, {
            key: 0,
            class: "punch_loading"
          }))
        : _createCommentVNode("", true),
      (Postes.value.length === 0)
        ? (_openBlock(), _createBlock(_unref(aEmpty), {
            key: 1,
            class: "empty_wrap",
            image: _unref(punchEmpty),
            description: "页面暂无数据信息~"
          }, null, 8, ["image"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_a_button, {
      type: "primary",
      class: "export_but",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(exportOut)(37)))
    }, {
      default: _withCtx(() => [
        _createTextVNode("导出")
      ]),
      _: 1
    })
  ], 512))
}
}

})